
import { Observable, throwError as observableThrowError, Subject, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { RestApi } from '../../../auth/rest.api';
import { BzAlertService } from '../../../shared/components/alert/alert.service';
import { EBzAlertTypes } from '../../../shared/components/alert/core/models/eAlertTypes.enum';
import { saveFile } from 'app/app.module';
import { catchError, map } from 'rxjs/operators';

declare global {
  interface Navigator {
    msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void;
  }
}

@Injectable()
export class TraceServiceImprovement {
  private api_name = 'api/Trace2';

  constructor(
    private _authHttp: RestApi,
    private _bzAlertService: BzAlertService
  ) {
  }

  public getCategories(): Observable<void> {
    return this._authHttp.get(`${this.api_name}/GetFilters`);
  };

  public getFileNames(filterCriteria: ITraceFilterManagement): Observable<void> {
    return this._authHttp.post(`${this.api_name}/FileNames`, filterCriteria);
  }

  public deleteFile(downloadFiles: Array<string>): Observable<void> {
    return this._authHttp.post(`${this.api_name}/DeleteFile`, downloadFiles);
  }

  public getTraceDetail(contentFilter: IContentFilter): Observable<void> {
    return this._authHttp.post(`${this.api_name}/GetContent`, contentFilter);
  }

  public downloadTraceFile(downloadFiles: Array<string>, nameFile) {
    return this._authHttp.requestBlob(
      {
        url: `${this.api_name}/DownloadFile`,
        parameters: [],
        body: downloadFiles
      }, 'POST')
      .map(result => {
        const fileName: string = this._authHttp.getFileNameFromHeaders(result.headers, nameFile);
        const pdfUrl = (window.URL || window['webkitURL']).createObjectURL(new Blob([result.body], { type: 'application/octet-stream' }));
        const anchor = document.createElement('a');
        anchor.download = fileName;
        anchor.href = pdfUrl;
        anchor.click();
      });
  }
}
